export type ActivityKind = "gym" | "run" | "bike" | "rest" | "swim";
export type Phase = "base" | "build" | "peak";

export interface Exercise { label: string; icon: string; }
export interface PlannedMeal {
  time: string; name: string; icon?: string; items: string[];
  cal: number; pro: number; careem?: boolean; restaurant?: string;
}
export interface PlannedTraining {
  icon?: string; title: string; time?: string; detail?: string;
  note?: string; calBurn: number;
}
export interface PlanDay {
  dateISO: string; date: string; dow: string; week: number; phase: Phase;
  type: ActivityKind; training: PlannedTraining; meals: PlannedMeal[];
  target: number; lunchNote?: string; note?: string;
  exercises?: Exercise[];
}

export type MealStatus = "planned" | "eaten" | "skipped";
export type WorkoutConfirmation =
  "pending" | "auto-confirmed" | "user-confirmed" | "skipped" | "different";

export interface LoggedMeal {
  plannedIndex: number | null;
  status: MealStatus;
  overrideCal?: number | null;
  overrideProtein?: number | null;
  adhocName?: string | null;
  note?: string | null;
}

export interface ExerciseActual {
  kcal?: number | null;
  durationMin?: number | null;
  distanceKm?: number | null;
  note?: string | null;
  sourceUploadId?: string | null;
  recordedAt?: string;
}

export interface DailyLog {
  dateISO?: string;
  meals?: LoggedMeal[];
  workoutConfirmation?: WorkoutConfirmation;
  workoutNote?: string;
  matchedWorkoutIds?: string[];
  completedExerciseIndices?: number[];
  exerciseActuals?: Record<string, ExerciseActual>;
}

export interface DayBundle {
  plan: PlanDay;
  log: DailyLog | null;
}

export const TYPE_COLOR: Record<ActivityKind, string> = {
  gym: "#38bdf8", run: "#e8ff47", bike: "#fb923c", swim: "#a78bfa", rest: "#2dd4bf",
};
